import mutations from "./mutations";
import getters from "./getters";

export const namespace = "fnMenu";

export const menuStore = (action) => {
    return namespace + "/" + action;
};

export const store_ = {
    namespaced: true,
    state: {
        menus: {}
    },
    getters,
    mutations
};

export default {
    /**
     * Install the auth store into the app store
     *
     * @param store {{registerModule: function(string,Object)}}
     */
    install: function(store){
        store.registerModule(namespace, store_);
    }
};
